import { OrderAssistBffApi } from './order-assist-bff';

export const internalApi = {
  orderAssistBff: new OrderAssistBffApi(),
};
